import instance from 'utils/apiCalls';
import { SUBSIDY_WITH_INCOME_URLS } from './SubsidyWithIncomeUrls';
import { WithIncomeInterface } from '../../../types/interface';

export const createWithIncomeConfiguration =
  (applicationType: number, data: { configurations: WithIncomeInterface[] }) =>
  async () => {
    const response = await instance.post(
      `${SUBSIDY_WITH_INCOME_URLS.CREATE_WITH_INCOME_CONFIGURATION}/${applicationType}`,
      data
    );
    return response;
  };

export const updateWithIncomeConfiguration =
  (applicationType: number, data: { configurations: WithIncomeInterface[] }) =>
  async () => {
    const response = await instance.put(
      `${SUBSIDY_WITH_INCOME_URLS.UPDATE_WITH_INCOME_CONFIGURATION}/${applicationType}`,
      data
    );
    return response;
  };

export const getAllWithIncomeConfiguration =
  (applicationType: number | undefined) => async () => {
    const response = await instance.get(
      `${SUBSIDY_WITH_INCOME_URLS.GET_ALL_WITH_INCOME_CONFIGURATION}/${applicationType}`
    );
    return response;
  };

export const getAllApplicationTypeOption = () => async () => {
  const response = await instance.get(
    SUBSIDY_WITH_INCOME_URLS.GET_ALL_APPLICATION_TYPE_REQUEST
  );
  return response;
};

export const getSingleWithIncomeConfiguration =
  (master_app_id: number) => async () => {
    const response = await instance.get(
      `${SUBSIDY_WITH_INCOME_URLS.GET_SINGLE_WITH_INCOME_CONFIGURATION}/${master_app_id}`
    );
    return response;
  };

export const deleteWithIncomeConfiguration =
  (with_income_configuration_id: number) => async () => {
    const response = await instance.delete(
      `${SUBSIDY_WITH_INCOME_URLS.DELETE_WITH_INCOME_CONFIGURATION}/${with_income_configuration_id}`
    );
    return response;
  };
